"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var _has = _interopRequireDefault(require("lodash/has"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _CaretDown = _interopRequireDefault(require("@decisiv/iconix/lib/components/CaretDown"));

var _CaretUp = _interopRequireDefault(require("@decisiv/iconix/lib/components/CaretUp"));

var _propTypes2 = require("@decisiv/prop-types");

var _designTokens = require("@decisiv/design-tokens");

var _styleModifiers = require("../../../utils/styleModifiers");

var _Flex = _interopRequireDefault(require("../../Flex"));

var _Tooltip = _interopRequireDefault(require("../../Tooltip"));

var _Typography = require("../../Typography");

var _constants = require("../constants");

var _schema = _interopRequireDefault(require("./schema"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CounterWrapper = _styledComponents.default.div.withConfig({
  displayName: "Button__CounterWrapper",
  componentId: "sc-1tj5jqo-0"
})(["position:absolute;top:7px;left:0;right:0;display:flex;justify-content:center;"]);

var Counter = _styledComponents.default.div.withConfig({
  displayName: "Button__Counter",
  componentId: "sc-1tj5jqo-1"
})(["height:", ";border-radius:", ";padding:", ";background-color:", ";color:", ";font-size:10px;line-height:100%;font-family:", ";font-weight:", ";font-style:normal;display:flex;align-items:center;text-align:center;"], (0, _rem.default)(15), (0, _rem.default)(8), "".concat((0, _rem.default)(3), " ").concat((0, _rem.default)(4)), (0, _toColorString.default)(_designTokens.color.status.danger.medium), (0, _toColorString.default)(_designTokens.color.base.snowWhite), _designTokens.typography.typeface.mono, _designTokens.typography.weight.alias.default);

var CustomButton = _styledComponents.default.button.withConfig({
  displayName: "Button__CustomButton",
  componentId: "sc-1tj5jqo-2"
})(["position:relative;align-items:center;background-color:", ";border:2px solid transparent;color:", ";cursor:pointer;display:flex;padding:0 ", ";text-align:left;&:hover{background-color:", ";}&:focus{outline:0;border-color:", ";}", ";", ";"], (0, _toColorString.default)(_constants.BG_COLOR), (0, _toColorString.default)(_constants.BG_COLOR.fg), (0, _rem.default)(_constants.ELEMENT_PADDING), (0, _toColorString.default)(_constants.BG_COLOR_HOVER), (0, _toColorString.default)(_constants.BG_COLOR_FOCUS), (0, _styleModifiers.when)('expanded', (0, _styledComponents.css)(["background-color:", ";border-color:transparent;color:", ";&:hover,&:focus{background-color:", ";border-color:transparent;color:", ";}"], (0, _toColorString.default)(_constants.BG_COLOR_ACTIVE), (0, _toColorString.default)(_constants.BG_COLOR_ACTIVE.fg), (0, _toColorString.default)(_constants.BG_COLOR_ACTIVE), (0, _toColorString.default)(_constants.BG_COLOR_ACTIVE.fg))), (0, _styleModifiers.when)('disabled', (0, _styledComponents.css)(["color:", ";&:hover,&:focus{background-color:", ";border:2px solid transparent;}"], (0, _toColorString.default)(_constants.ELEMENT_DISABLED_COLOR), (0, _toColorString.default)(_constants.BG_COLOR))));

var SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];

function abbreviateNumber(value) {
  var tier = Math.floor(Math.log10(value) / 3);

  if (tier === 0) {
    return value.toString();
  }

  var scale = Math.pow(10, tier * 3); // when it's way too large use scientific notation as suffix

  var suffix = SI_SYMBOL[tier] || "e".concat(tier * 3);
  return "".concat(Math.floor(value / scale)).concat(suffix, "+");
}

function Button(props, ref) {
  var disabled = props.disabled,
      Emblem = props.emblem,
      onClick = props.onClick,
      primaryText = props.primaryText,
      secondaryText = props.secondaryText,
      tooltipText = props.tooltipText,
      counter = props.counter;
  var expanded = (0, _get.default)(props, 'expanded');
  var withExpander = (0, _get.default)(props, 'withExpander');

  var Target = _react.default.createElement(CustomButton, {
    disabled: disabled,
    expanded: expanded,
    onClick: onClick,
    ref: ref
  }, counter ? _react.default.createElement(CounterWrapper, null, _react.default.createElement(Counter, null, abbreviateNumber(counter))) : null, Emblem && _react.default.createElement(_Flex.default, null, _react.default.createElement(Emblem, null)), primaryText && _react.default.createElement(_Flex.default, {
    flexDirection: "column",
    marginLeft: Emblem ? 1 : 0
  }, _react.default.createElement(_Typography.H4, {
    as: "span",
    truncate: true,
    weight: "semibold"
  }, primaryText), secondaryText && _react.default.createElement(_Typography.P, {
    as: "span",
    color: disabled || expanded ? 'alaskanHusky' : 'halfMoon',
    truncate: true
  }, secondaryText)), withExpander && _react.default.createElement(_Flex.default, {
    marginLeft: 0.5
  }, expanded ? _react.default.createElement(_CaretUp.default, {
    size: "small"
  }) : _react.default.createElement(_CaretDown.default, {
    size: "small"
  })));

  if (tooltipText && !expanded) {
    return _react.default.createElement(_Tooltip.default, {
      target: Target,
      placement: "bottom"
    }, tooltipText);
  }

  return Target;
}

var ButtonWithRef = (0, _react.forwardRef)(Button); // @ts-ignore

ButtonWithRef.propTypes = _objectSpread({}, _schema.default.propTypes, {
  expanded: (0, _propTypes2.forbiddenIf)(_propTypes.default.bool, function (props) {
    return !(0, _has.default)(props, 'withExpander');
  }),
  tooltipText: (0, _propTypes2.requireIf)(_propTypes.default.string, function (_ref) {
    var primaryText = _ref.primaryText;
    return (0, _isEmpty.default)(primaryText);
  })
});
var _default = ButtonWithRef;
exports.default = _default;